import React, { Fragment } from 'react'
import GeneralInput from '../../../../../components/GeneralInput'
import GeneralInputMask from '../../../../../components/GeneralInputMask'
import get from 'lodash/get'

const CreditSignup = ({
  dynamicData,
  name,
  email,
  password,
  confirmPassword,
  phone,
  cpf,
  handleAuthWithView,
  handleWithAuth,
  error,
}) => (
  <Fragment>
    <Fragment>
      {Boolean(error) && <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>}
    </Fragment>
    <GeneralInput handleChange={name} value={get(dynamicData, 'name')} type='text' label='Nome' />

    <GeneralInputMask
      handleChange={cpf}
      mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
      label='CPF'
    />

    <GeneralInput handleChange={email} type='email' label='Email' />

    <GeneralInput handleChange={password} type='password' label='Senha' />

    <GeneralInput handleChange={confirmPassword} type='password' label='Confirmar Senha' />

    <GeneralInputMask
      handleChange={phone}
      value={get(dynamicData, 'phone')}
      mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      label='Telefone'
    />

    <div className='auth_group'>
      <button onClick={handleAuthWithView} className='auth_register'>
        Voltar
      </button>
      <button onClick={handleWithAuth} className='auth_login'>
        Cadastrar
      </button>
    </div>
  </Fragment>
)

// TODO: use ts
// CreditSignup.propTypes = {
//   error: PropTypes.string,
//   name: PropTypes.func,
//   email: PropTypes.func,
//   password: PropTypes.func,
//   phone: PropTypes.func,
//   cpf: PropTypes.func,
//   confirmPassword: PropTypes.func,
//   handleWithView: PropTypes.func,
//   handleWithAuth: PropTypes.func,
// }

export default CreditSignup
